// Datos identificativos de la titular (según documentos legales aportados).
export const OWNER = {
  name: "Lorena Cuevas González",
  brand: "Lorena Cuevas",
  clinic: "Clínica Podológica Lorena Cuevas",
  nif: "47345759Y",
  address: "C/ Rodrigo de Triana, 21 – 41520 El Viso del Alcor (Sevilla)",
  addressShort: "C. Rodrigo de Triana, 21",
  city: "41520 El Viso del Alcor, Sevilla",
  email: "lorenacuevaspodo@gmail.com",
  phoneLegal: "645 230 794",
  phoneBooking: "674 980 080",
  phoneBookingRaw: "674980080",
  whatsapp: "34674980080",
  jurisdiction: "El Viso del Alcor",
};

export const WHATSAPP_MSG =
  "Hola Lorena, me gustaría reservar una cita en la clínica podológica. ¿Cuál es la próxima disponibilidad?";

export const whatsappLink = (msg = WHATSAPP_MSG) =>
  `https://wa.me/${OWNER.whatsapp}?text=${encodeURIComponent(msg)}`;

// Fecha de última actualización de los documentos legales.
export const LEGAL_UPDATED = "Junio de 2026";
